export default {
  campagne: 'Our campaigns',
  published: 'Published on',
  archivio: 'News Archive',
  notizieCorrelate: 'Related News',
  modalitaDusoVino: 'Instructions for use <br /> of yeast for <i>wine</i>',
  modalitaDusoBirra: 'Instructions for use <br /> of yeast for <i>beer</i>',
  buy: 'Buy',
  richiediInfo: 'Request info',
  etichettaAmbientale: 'Environmental Label',
  what: 'What it is',
  where: 'Where it goes',
  raccoltaPlastica: 'Plastic collection',
  disposizioni: 'Check the provisions of your municipality',
  disposizioniInfo:
    'Product for professional oenological use in accordance with: Reg. CEE/UE N°934/2019 and International Codex OIV',
  applicazioni: 'Applications',
  specificheTecniche: 'Technical specifications',
  preparazione: 'Preparation',
  scaricaScheda: 'Download data sheet',
  scaricaSchedaPanificati: 'Technical data sheet - Recipes',
  contenitore: 'Container',
  tappo: 'Cork',
  sottotappo: 'Under-cork',
  tappoFlacone: 'Bottle cap',
  tappoTanica: 'Can cap',
  sacchetto: 'Bag',
  vediNews: 'News archive',
  vediVideo: 'All videos',
  news: 'News',
  videos: 'Videos',
  leggi: 'Continue reading',
  indietro: 'Back',
  seeAll: 'See all',
  filtri: 'Filters',
  approfondisci: 'Discover more',
  prodotto: 'Go to product',
  cancellaFiltri: 'Clear filters',
  modelTitle: 'Our Atecnos: Pathfinders in the yeast revolution',
  modelText:
    'In 2012, we were the first to introduce cream yeasts to the market. Atecnos is distinctive thanks to a unique methodology that faithfully reproduces the natural processes of yeast propagation. We obtain a fresh, high-purity, extremely reactive and ready-to-use yeast that allows direct inoculation onto the must.',
  iubendaCookiePolicyId: '58968935',
}
